module.exports = __webpack_public_path__ + "img/trash.b86c4d72.svg";